import { Injectable } from '@angular/core';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import type { MasterMilestoneFindInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-find.dto';
import type { MasterMilestoneFindManyQueryInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-find-many-query.dto';
import type { MasterMilestoneItemsPageInterface } from '@zaoblako/shared/modules/catalog/dtos/master-milestone/master-milestone-items-page.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import { DirectoryHistoryServiceInterface } from '@zaoblako/shared/common/interfaces/directory-history-service.interface';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectMasterMilestoneService extends BaseService implements DirectoryHistoryServiceInterface {
  protected baseUrl = '/basis/catalog/master-milestone';

  public get dropdownDescriptorUrl(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }

  public getReportDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(this.baseUrl);
  }

  public findPage(queryParams?: MasterMilestoneFindManyQueryInterface): Observable<MasterMilestoneItemsPageInterface> {
    const params = queryParams ? this.objectToHttpParams(queryParams) : {};
    return this.http.get<MasterMilestoneItemsPageInterface>(`${this.baseUrl}/items`, { params });
  }

  public restoreOne(id: number): Observable<MasterMilestoneFindInterface> {
    return this.http.post<MasterMilestoneFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public getHistoryForOne(id: number, queryParams?: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
